import { render, staticRenderFns } from "./colorDetection.vue?vue&type=template&id=24bc2afa&scoped=true"
import script from "./colorDetection.vue?vue&type=script&lang=ts"
export * from "./colorDetection.vue?vue&type=script&lang=ts"
import style0 from "./colorDetection.vue?vue&type=style&index=0&id=24bc2afa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24bc2afa",
  null
  
)

export default component.exports